import React from 'react'
import styled from 'styled-components'
import { NudistaMedium14, NudistaMedium9 } from '../Common/Fonts'

const subdirectories = [
  {
    name: 'Front Elevation',
    number: '54',
    id: '1',
  },
  {
    name: 'Right Elevation',
    number: '23',
    id: '2',
  },
  {
    name: 'Rear Elevation',
    number: '55',
    id: '3',
  },
  {
    name: 'Left Elevation',
    number: '123',
    id: '4',
  },
  {
    name: 'Roof',
    number: '65',
    id: '5',
  },
]

const SubdirLayout = ({ thumbsviewNavbarMinified }) => {
  return (
    <div>
      {subdirectories?.map((value) => (
        <RowFlexDiv
          width={thumbsviewNavbarMinified ? '0px' : '100%'}
          opacity={thumbsviewNavbarMinified ? '0' : '1'}
          zIndex={thumbsviewNavbarMinified ? '-100' : '1'}
          height='27px'
        >
          <ColumnFlexDiv
            height='100%'
            backgroundColor='#707070'
            width='1px'
            marginLeft='5%'
          ></ColumnFlexDiv>

          <RowFlexDiv
            height='1px'
            backgroundColor='#707070'
            width='8px'
          ></RowFlexDiv>

          <RowFlexDiv
            height='20px'
            width={thumbsviewNavbarMinified ? '0px' : '85%'}
            opacity={thumbsviewNavbarMinified ? '0' : '1'}
            zIndex={thumbsviewNavbarMinified ? '-100' : '1'}
          >
            <NudistaMedium14> {value.name}</NudistaMedium14>
          </RowFlexDiv>

          <RowFlexDiv
            height='20px'
            width='25px'
            opacity='0.38'
            justifyContent='center'
            borderRadius='6px'
            outline='1px solid green'
            marginLeft='30px'
          >
            <NudistaMedium9> {value.number}</NudistaMedium9>
          </RowFlexDiv>
        </RowFlexDiv>
      ))}
    </div>
  )
}

const ColumnFlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-overflow: ellipsis;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};

  background-color: ${(props) => props.backgroundColor};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
`

const RowFlexDiv = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  outline: ${(props) => props.outline};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  text-overflow: ellipsis;
  white-space: nowrap;

  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  align-items: center;
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  margin-left: ${(props) => props.marginLeft};
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius};
`

export default SubdirLayout
